<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">Set As Approver</h1>
      <p class="hris-page-subtitle">Search for an employee and toggle their approver status.</p>
    </div>

    <q-form ref="vForm" @submit="onSubmitSearch">
      <div class="hris-toolbar">
        <q-input
          outlined
          dense
          color="green"
          v-model="searchModel"
          :rules="[formRules.required]"
          placeholder="Search employee here..."
          style="min-width: 280px; flex: 1 1 320px; max-width: 480px;"
        >
          <template v-slot:append>
            <q-icon name="fa fa-search"></q-icon>
          </template>
        </q-input>
        <q-btn unelevated class="hris-q-primary" type="submit" label="Search"></q-btn>
      </div>
    </q-form>

    <div class="hris-panel">
      <h2 class="hris-panel-title">Search Result</h2>
      <q-table id="result-list" flat :data="searchResultData" :columns="searchResultColumns" row-key="id" :hide-bottom="searchResultData.length > 0" :loading="loading">
        <q-tr slot="body" slot-scope="props" :props="props">
          <q-td key="employee_id" :props="props">{{ props.row.employee_id }}</q-td>
          <q-td key="name" :props="props">{{ props.row.name }}</q-td>
          <q-td key="position" :props="props">{{ props.row.position }}</q-td>
          <q-td key="department" :props="props">{{ props.row.department }}</q-td>
          <q-td key="action" :props="props">
            <q-toggle :props="props" v-model="props.row.is_approver" @input="setState(props.row.is_approver,props.row.id)" checked-icon="fa fa-check" color="green" unchecked-icon="fa fa-times">
              <q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
                <strong>Set As Approver</strong>
              </q-tooltip>
            </q-toggle>
          </q-td>
        </q-tr>
        <template v-slot:no-data="{ message }">
          <div class="hris-empty full-width">
            {{ message }}
          </div>
        </template>
      </q-table>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios';

const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};

export default {
  name: 'SetAsApprover',
  data() {
    return {
      loading: false,
      searchModel: null,
      searchResultData: [],
      searchResultColumns: [{
          name: 'employee_id',
          field: 'employee_id',
          label: 'Employee ID',
          style: 'width: 200px',
          align: 'center',
          headerStyle: 'width: 200px'
        },
        {
          name: 'name',
          field: 'name',
          label: 'Name',
          style: 'width: 300px; padding-left: 100px',
          align: 'left',
          headerStyle: 'width: 300px; text-align:center'
        },
        {
          name: 'position',
          field: 'position',
          label: 'Position',
          style: 'width: 300px; padding-left: 100px',
          align: 'left',
          headerStyle: 'width: 300px; text-align:center'
        },
        {
          name: 'department',
          field: 'department',
          label: 'Department',
          align: 'center',
        },
        {
          name: 'action',
          field: 'action',
          label: 'Action',
          align: 'center',
        }
      ],
      form: {
        employee_id: '',
        status: ''
      },
    }
  },
  methods: {
    onSubmitSearch: function() {
      this.loading = true;

      axios.create({
          baseURL: this.apiUrl,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
        .get('/employees/search', {
          params: {
            keyword: this.searchModel
          }
        })
        .then((res) => {
          this.loading = false;
          this.searchResultData = [];
          if (res.data.data.length > 0) {
            for (let emp of res.data.data) {
              if (emp.is_approver == 'yes') {
                emp.is_approver = true;
              } else {
                emp.is_approver = false;
              }
              this.searchResultData.push({
                id: emp.id,
                name: this.toTitleCase(emp.name),
                employee_id: emp.employee_id,
                position: emp.position,
                department: emp.department,
                is_approver: emp.is_approver
              });
            }
          }
        })
    },

    setState: function(status, empID) {
      this.form.employee_id = empID;
      this.form.status = status;

      let formData = new FormData();

      formData.append('form_data', JSON.stringify(this.form));

      axios.create({
        baseURL: this.apiUrl,
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      }).post('/employees/status/set-as-approver', formData).then((res) => {
        console.log('Successfully Set Approver Status');
        this.form.employee_id = '';
        this.form.status = '';
      })

      this.$q.notify({
        color: 'green-7',
        textColor: 'white',
        icon: 'fa fa-file-signature',
        message: 'Successfully Set Approver Status'
      });
    }
  }
}
</script>
<style lang="css" scoped>
#result-list tr:hover {
  cursor: default;
}
</style>